<template>
  <div class="white-container channel-page">
    <el-button v-if=" activeName === 'one' && curHometype === 1" size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="homeBannerAdd">新增</el-button>
    <el-tabs v-model="activeName" :before-leave="beforeLeave" class="channel-tabs">
      <el-tab-pane label="首页" name="one">
        <el-form ref="homeForm" class="home-form" size="small" label-width="96px">
          <el-form-item label="选择首页模块" style="width:300px">
            <el-select v-model="curHometype" placeholder="请选择首页模块" @change="handleHomeModelChange">
              <el-option v-for="item in homeModelTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <div class="home-form-body">
            <template v-if="curHometype === 1">
              <el-form ref="homeForm1" class="home-banner-form" :model="homeForm1" :rules="homeRules1" size="small" label-width="96px">
                <div v-for="(item,index) in homeForm1.value" :key="index" class="card">
                  <div class="index">序号&emsp;{{ index+1 }}</div>
                  <el-form-item :prop="`value.${index}.imageUrl`" label-width="0" :rules="homeRules1.imageUrl">
                    <div class="img-wrap">
                      <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/homeBanner/'" size-tips="750*750px" @upload="oneUp($event,index)" />
                    </div>
                  </el-form-item>
                  <div>
                    <el-form-item label="主标题" :prop="`value.${index}.title`" :rules="homeRules1.title">
                      <el-input v-model="item.title" maxlength="9" class="common-input w-360" placeholder="输入标题文案，最长输入9个汉字" />
                    </el-form-item>
                    <el-form-item label="副标题">
                      <el-input v-model="item.subTitle" maxlength="18" class="common-input w-360" placeholder="输入标题文案，最长输入18个汉字" />
                    </el-form-item>
                    <el-form-item label="链接地址" :prop="`value.${index}.linkUrl`" :rules="homeRules1.linkUrl">
                      <el-input v-model="item.linkUrl" class="common-input w-360" placeholder="请填写banner跳转地址链接" />
                    </el-form-item>
                    <el-form-item label="会员可见">
                      <el-select v-model="item.visibleUserLevel" placeholder="请选择是否可见">
                        <el-option v-for="vip in vipMap" :key="vip.id + vip.label" :label="vip.label" :value="vip.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="可见渠道">
                      <el-select v-model="item.channelVisible" placeholder="请选择可见渠道">
                        <el-option v-for="fp in homefpMap" :key="fp.id + fp.label" :label="fp.label" :value="fp.value" />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="operate-wrap">
                    <el-button type="primary" size="small" @click="homeBannerReset(1,index)">删除</el-button>
                  </div>
                </div>
              </el-form>

            </template>
            <template v-if="curHometype === 2">
              <el-form class="home-banner-form" :model="homeForm2" size="small" label-width="96px">
                <div v-for="(item,index) in homeForm2.value" :key="index" class="card">
                  <div class="index">序号&emsp;{{ index+1 }}</div>
                  <div class="img-wrap">
                    <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/homeBanner/'" size-tips="888*630px" @upload="twoUp($event,index)" />
                  </div>
                  <div>
                    <el-form-item label="主标题">
                      <div class="mainTitleWrap flex">
                        <div v-for="(mainTitle,titleN) in item.titleList" :key="titleN+'mainTitle'">
                          <el-input v-model="item.titleList[titleN]" maxlength="8" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案，最长8个汉字' : '请输入第二行主标题文案，最长8个汉字' " />
                        </div>
                      </div>

                    </el-form-item>
                    <el-form-item label="副标题">
                      <el-input v-model="item.subTitle" maxlength="15" class="common-input" style="width: 750px;" placeholder="请输入副标题文案，最长15个汉字" />
                    </el-form-item>
                    <el-form-item label="链接地址">
                      <el-input v-model="item.linkUrl" class="common-input" style="width: 750px;" placeholder="请填写banner跳转地址链接" />
                    </el-form-item>
                    <el-form-item label="会员可见">
                      <el-select v-model="item.visibleUserLevel" class="w750" placeholder="请选择是否可见" @change="onLevelChange($event,index)">
                        <el-option v-for="vip in vipMap" :key="vip.id + vip.label" :label="vip.label" :value="vip.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.visibleUserLevel !== 0" label="等级文案">
                      <el-input v-model="item.levelCopyrighting" maxlength="14" class="common-input" style="width: 750px;" placeholder="请输入等级相关提示文案，最长14个汉字" />
                    </el-form-item>
                  </div>

                  <div v-if="item.imageUrl || item.titleList[0]|| item.titleList[1] || item.subTitle|| item.linkUrl || item.levelCopyrighting" class="operate-wrap">
                    <el-button type="primary" size="small" @click="homeBannerReset(2,index)">重置</el-button>
                  </div>
                </div>
              </el-form>
            </template>
            <template v-if="curHometype === 3">
              <div class="banner-class-wrap">
                <div v-for="(c,cI) in homeForm3.value" :key="cI" class="banner-class-box flex">
                  <div class="first">
                    <img :src="c.imageUrl" alt="">
                  </div>
                  <div class="second flex">
                    <div class="second-item">
                      <span>标题：</span>
                      <span>{{ c.courseName }}</span>
                    </div>
                    <div class="second-item">
                      <span>类型：</span>
                      <span>{{ c.seriesTag || '--' }}</span>
                    </div>
                    <div class="second-item">
                      <span>标签：</span>
                      <span>{{ c.tag }}</span>
                    </div>
                    <div class="second-operate" @click="removeClass(cI)">
                      取消推荐
                    </div>
                  </div>
                </div>
              </div>
              <div class="add-class-wrap">
                <div class="title">添加推荐课程</div>
                <el-form class="home-class-form" label-width="auto">
                  <div class="flex">
                    <el-form-item label="选择课程">
                      <el-autocomplete v-model="className" class="autocomplete-input" :fetch-suggestions="querySearch" placeholder="输入课程标题后选择" :trigger-on-focus="false" @select="handleSelect" />
                    </el-form-item>
                    <el-form-item label="标签" label-width="100px">
                      <el-input v-model="classTag" class="common-input w-360" placeholder="选填，最多4个汉字" maxlength="4" />
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" size="small" icon="el-icon-plus" @click="addClass">添加</el-button>
                    </el-form-item>
                  </div>
                </el-form>
              </div>

            </template>
            <template v-if="curHometype === 5">
              <el-form ref="homeForm5" class="home-banner-form" :model="homeForm5" :rules="homeRules5" size="small" label-width="96px">
                <div v-for="(item,index) in homeForm5.value" :key="index" class="card">
                  <div class="index">序号&emsp;{{ index+1 }}</div>
                  <el-form-item :prop="`value.${index}.imageUrl`" label-width="0" :rules="homeRules5.imageUrl">
                    <div class="img-wrap">
                      <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/homeBanner/'" size-tips="1005*810px" @upload="fiveUp($event,index)" />
                    </div>
                  </el-form-item>
                  <div>
                    <el-form-item label="主标题" :prop="`value.${index}.content`" :rules="homeRules5.content">
                      <el-input v-model="item.content" maxlength="9" class="common-input w-360" placeholder="主标题" />
                    </el-form-item>
                    <el-form-item label="活动日期" :prop="`value.${index}.time`" :rules="homeRules5.time">
                      <el-date-picker
                        v-model="item.time"
                        style="width:360px"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="活动开始日期"
                        end-placeholder="活动结束日期"
                        value-format="yyyy-MM-dd"
                        @change="handleReceiveTimeChange"
                      />
                    </el-form-item>
                    <el-form-item label="按钮文案" :prop="`value.${index}.btnContent`" :rules="homeRules5.btnContent">
                      <el-input v-model="item.btnContent" maxlength="18" class="common-input w-360" placeholder="输入按钮文案" />
                    </el-form-item>
                    <el-form-item label="活动链接" :prop="`value.${index}.landingPageUrl`" :rules="homeRules5.landingPageUrl">
                      <el-input v-model="item.landingPageUrl" class="common-input w-360" placeholder="请填写活动链接" />
                    </el-form-item>
                  </div>
                  <div class="operate-wrap">
                    <el-button type="primary" size="small" @click="reset5(index)">重置</el-button>
                  </div>
                </div>
              </el-form>
            </template>
          </div>
        </el-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="课程/活动频道" name="two">
        <div class="two-form-body">
          <el-form class="two-banner-form" :model="classEventForm" size="small" label-width="96px">
            <div v-for="(item,index) in classEventForm.value" :key="index" class="card">
              <div class="index">序号&emsp;{{ index+1 }}</div>
              <div class="img-wrap">
                <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/classEventBanner/'" size-tips="900*300px" @upload="classEventUp($event,index)" />
              </div>
              <div>
                <el-form-item label="链接地址">
                  <el-input v-model="item.linkUrl" class="common-input w-360" placeholder="请填写banner跳转地址链接" />
                </el-form-item>
                <el-form-item label="会员可见">
                  <el-select v-model="item.visibleUserLevel" placeholder="请选择是否可见">
                    <el-option v-for="vip in vipMap" :key="vip.id + vip.label" :label="vip.label" :value="vip.value" />
                  </el-select>
                </el-form-item>

                <el-form-item label="FP渠道可见">
                  <el-select v-model="item.fpVisible" placeholder="请选择是否可见">
                    <el-option v-for="fp in fpMap" :key="fp.id + fp.label" :label="fp.label" :value="fp.value" />
                  </el-select>
                </el-form-item>
              </div>
              <div v-if="item.linkUrl || item.fpVisible !== null" class="operate-wrap">
                <el-button type="primary" size="small" @click="classEventReset(index)">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="积分兑换频道" name="three">
        <div class="two-form-body">
          <el-form class="two-banner-form" :model="integralExchangeForm" size="small" label-width="96px">
            <div v-for="(item,index) in integralExchangeForm.value" :key="index" class="card">
              <div class="img-wrap">
                <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/integralExchangeBanner/'" size-tips="1005*335px" @upload="integralExchangeUp($event,index)" />
              </div>
              <div>
                <el-form-item label="链接地址" style="margin-bottom: unset;">
                  <el-input v-model="item.linkUrl" class="common-input w-360" placeholder="请填写banner跳转地址链接" />
                </el-form-item>
              </div>
              <div v-if="item.linkUrl" class="operate-wrap">
                <el-button type="primary" size="small" @click="integralExchangeReset(index)">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="课程tab页面" name="four">
        <el-form lass="home-form" size="small" label-width="96px">
          <div class="home-form-body">
            <template>
              <!-- <el-form class="home-banner-form" :model="homeForm4" :rules="homeRules1" size="small" label-width="96px"> -->
              <div v-for="(item,index) in homeForm4.value" :key="index" class="card card-flex">
                <div class="index">序号&emsp;{{ index+1 }}</div>
                <el-form-item :prop="`value.${index}.imageUrl`" label-width="0" :rules="homeRules1.imageUrl">
                  <div class="img-wrap">
                    <UploadImage :show-replace="false" :limit-size="5" :url="item.imageUrl" :save-path="'miniAppConfig/channelPage/homeBanner/'" size-tips="1005*726px" @upload="threeUp($event,index)" />
                  </div>
                </el-form-item>
                <div class="flex">
                  <el-form-item label="选择课程">
                    <el-autocomplete v-model="item.title" class="autocomplete-input" :fetch-suggestions="querySearch" placeholder="输入课程标题后选择" :trigger-on-focus="false" @select="handleSelect4($event,index)" />
                  </el-form-item>
                  <el-form-item>
                    <div class="flex">
                      <el-button type="primary" size="small" @click="reset4(index)">重置</el-button>
                      <el-button v-if="index>=1" type="danger" size="small" @click="delete4(index)">删除</el-button>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="btn-box">
                <div class="flex add-btn" @click="addItem4">
                  <i class="el-icon-plus" /> 添加课程
                </div>
              </div>
              <!-- </el-form> -->
            </template>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <div class="flex btns">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>
<script>
import UploadImage from './uploadImage.vue';
import FunctionUtils from "@/utils/functionUtils";
import { HomeModel, IntegralExchange } from "@/model/ChannelPage";
export default {
  components: { UploadImage },
  data() {
    const homeModelTypes = [
      {
        value: 1,
        label: '首页主banner',
      },
      {
        value: 2,
        label: '运动家俱乐部banner',
      },
      {
        value: 3,
        label: '首页课程推荐',
      },
      {
        value: 5,
        label: '月度打卡配置',
      },
    ];
    const vipMap = [
      { id: 0, label: '所有会员可见', value: 0 },
      { id: 1, label: 'Lv2及以上可见', value: 2 },
      { id: 2, label: 'Lv3及以上可见', value: 3 },
      { id: 3, label: 'Lv4及以上可见', value: 4 },
      { id: 4, label: 'Lv5可见', value: 5 },

    ];
    const fpMap = [
      { id: 0, label: '可见', value: true },
      { id: 1, label: '不可见', value: false },
    ];
    const homefpMap = [
      { id: 0, label: '全渠道可见', value: 0 },
      { id: 1, label: '仅FP可见', value: 1 },
      { id: 2, label: '仅非FP可见', value: 2 },
    ];
    return {
      vipMap,
      homefpMap,
      fpMap,
      activeName: 'one',
      curHometype: 1,
      homeForm1: new HomeModel(),
      homeForm2: new HomeModel(null, 2),
      homeForm3: new HomeModel(null, 3),
      homeForm4: new HomeModel(null, 4),
      homeForm5: new HomeModel(null, 5),
      // classEventForm: new ClassEvents(),
      integralExchangeForm: new IntegralExchange(),
      homeModelTypes,
      className: '',
      classTag: '',
      selectItem: null,
      homeRules1: {
        imageUrl: [
          { required: true, message: '请上传图片', trigger: ['blur', 'change'] },
        ],
        title: [
          { required: true, message: '请输入主标题', trigger: ['blur', 'change'] },
        ],
        linkUrl: [
          { required: true, message: '请输入链接地址', trigger: ['blur', 'change'] },
        ],
      },
      homeRules5: {
        imageUrl: [
          { required: true, message: '请上传图片', trigger: ['blur', 'change'] },
        ],
        content: [
          { required: true, message: '请输入主标题', trigger: ['blur', 'change'] },
        ],
        time: [
          { required: true, message: '请选择时间', trigger: ['blur', 'change'] },
        ],
        btnContent: [
          { required: true, message: '请输入按钮文案', trigger: ['blur', 'change'] },
        ],
        landingPageUrl: [
          { required: true, message: '请输入活动链接', trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  created() {
    this.handleHomeModelChange(this.curHometype);
  },
  methods: {
    beforeLeave(activeName, oldActiveName) {
      switch (activeName) {
        case 'one':
          this.handleHomeModelChange(this.curHometype);
          break;
        // case 'two':
        //   this.fetchClassEvent();
        //   break;
        case 'three':
          this.fetchIntegralExchange();
          break;
        case 'four':
          this.handleHomeModelChange(4);
          break;
        default:
          break;
      }
    },
    handleHomeModelChange(e) {
      if (e === 1) {
        this.fetch1();
      } else if (e === 2) {
        this.fetch2();
      } else if (e === 3) {
        this.fetch3();
      } else if (e === 4) {
        this.fetch4();
      } else if (e === 5) {
        this.fetch5();
      }
    },
    oneUp(file, index) {
      const list = FunctionUtils.deepClone(this.homeForm1.value);
      list[index].imageUrl = file;
      this.homeForm1.value = list;
    },
    twoUp(file, index) {
      const list = FunctionUtils.deepClone(this.homeForm2.value);
      list[index].imageUrl = file;
      this.homeForm2.value = list;
    },
    threeUp(file, index) {
      const list = FunctionUtils.deepClone(this.homeForm4.value);
      list[index].imageUrl = file;
      this.homeForm4.value = list;
    },
    fiveUp(file, index) {
      const list = FunctionUtils.deepClone(this.homeForm5.value);
      list[index].imageUrl = file;
      this.homeForm5.value = list;
    },
    handleReceiveTimeChange(value) {
      console.log('value', value);
      if (value) {
        this.homeForm5.value[0].beginTime = value[0];
        this.homeForm5.value[0].endTime = value[1];
      } else {
        this.homeForm5.value[0].beginTime = '';
        this.homeForm5.value[0].endTime = '';
      }
    },
    // classEventUp(file, index) {
    //   const list = FunctionUtils.deepClone(this.classEventForm.value);
    //   list[index].imageUrl = file;
    //   this.classEventForm.value = list;
    // },
    integralExchangeUp(file, index) {
      const list = FunctionUtils.deepClone(this.integralExchangeForm.value);
      list[index].imageUrl = file;
      this.integralExchangeForm.value = list;
    },
    homeBannerAdd() {
      this.homeForm1.value.push({
        imageUrl: '',
        title: '',
        subTitle: '',
        linkUrl: '',
        visibleUserLevel: 0,
        channelVisible: 0,
      });
    },
    // 首页主banner重置
    homeBannerReset(type, i) {
      // 就首页主banner这个添加新增删除 --2024.5.10By Vb
      if (type === 1) {
        const list = FunctionUtils.deepClone(this.homeForm1.value);
        // 数组删除
        list.splice(i, 1);
        this.homeForm1.value = list;
      } else if (type === 2) {
        const list = FunctionUtils.deepClone(this.homeForm2.value);
        list[i] = {
          imageUrl: '',
          titleList: ['', ''],
          subTitle: '',
          linkUrl: '',
          visibleUserLevel: 0,
          levelCopyrighting: '',
        };
        this.homeForm2.value = list;
      }
    },
    // 课程/活动频道重置
    // classEventReset(i) {
    //   const list = FunctionUtils.deepClone(this.classEventForm.value);
    //   list[i] = {
    //     imageUrl: '',
    //     linkUrl: '',
    //     visibleUserLevel: 0,
    //     fpVisible: null,
    //   };
    //   this.classEventForm.value = list;
    // },
    // 积分兑换重置
    integralExchangeReset(i) {
      const list = FunctionUtils.deepClone(this.integralExchangeForm.value);
      list[i] = {
        imageUrl: '',
        linkUrl: '',
      };
      this.integralExchangeForm.value = list;
    },
    submit() {
      switch (this.activeName) {
        case 'one':
          switch (this.curHometype) {
            case 1:
              this.sendHomeBanner1();
              break;
            case 2:
              this.sendHomeBanner2();
              break;
            case 3:
              this.sendHomeBanner3();
              break;
            case 5:
              this.sendHomeBanner5();
              break;
            default:
              break;
          }
          break;
        case 'two':
          this.sendClassEvent();
          break;
        case 'three':
          this.sendIntegralExchange();
          break;
        case 'four':
          this.sendHomeBanner4();
          break;
        default:
          break;
      }
    },
    fetch1() {
      this.$Api.channelPage.postCPCC({
        key: 'main_banner',
        segment: 'home_page_module',
      }).then(res => {
        if (res) {
          this.homeForm1 = new HomeModel(res);
        }
      });
    },
    fetch2() {
      this.$Api.channelPage.postCPCC({
        key: 'sports_club_banner',
        segment: 'home_page_module',
      }).then(res => {
        if (res) {
          this.homeForm2 = new HomeModel(res, 2);
        }
      });
    },
    fetch3() {
      this.$Api.channelPage.postCPCC({
        key: 'course_recommendation',
        segment: 'home_page_module',
      }).then(res => {
        if (res) {
          this.homeForm3 = new HomeModel(res, 3);
        }
      });
    },
    fetch5() {
      this.$Api.channelPage.postCPCC({
        key: 'series_task_activity_index_new',
        segment: 'home_page_module',
      }).then(res => {
        this.homeForm5 = new HomeModel(res, 5);
      });
    },
    reset5(index) {
      const list = FunctionUtils.deepClone(this.homeForm5.value);
      list[index].content = '';
      list[index].btnContent = '';
      list[index].beginTime = '';
      list[index].endTime = '';
      list[index].landingPageUrl = '';
      this.homeForm5.value = list;
    },
    fetch4() {
      this.$Api.channelPage.postCPCC({
        key: 'course_index_banner',
        segment: 'course_page_module',
      }).then(res => {
        this.homeForm4 = new HomeModel(res, 4);
      });
    },
    reset4(index) {
      const list = FunctionUtils.deepClone(this.homeForm4.value);
      list[index].imageUrl = '';
      list[index].courseId = '';
      list[index].title = '';
      list[index].id = '';
      this.homeForm4.value = list;
    },
    delete4(index) {
      const list = FunctionUtils.deepClone(this.homeForm4.value);
      list.splice(index, 1);
      this.homeForm4.value = list;
    },
    addItem4() {
      const list = FunctionUtils.deepClone(this.homeForm4.value);
      const len = list.length;
      list[len] = {};
      list[len].imageUrl = '';
      list[len].courseId = '';
      list[len].title = '';
      list[len].id = '';
      this.homeForm4.value = list;
    },
    // fetchClassEvent() {
    //   this.$Api.channelPage.postCPCC({
    //     key: 'course_activity_channel',
    //     segment: 'course_activity',
    //   }).then(res => {
    //     if (res) {
    //       this.classEventForm = new ClassEvents(res);
    //     }
    //   });
    // },
    fetchIntegralExchange() {
      this.$Api.channelPage.postCPCC({
        key: 'integral_exchange_channel',
        segment: 'integral_exchange',
      }).then(res => {
        if (res) {
          this.integralExchangeForm = new IntegralExchange(res);
        }
      });
    },
    onLevelChange(e, i) {
      const strMap = {
        0: '',
        2: 'LV2新秀崛起以上会员专享',
        3: 'LV3黑马出世以上会员专享',
        4: 'LV4荣耀精英以上会员专享',
        5: 'LV5黑钻健将以上会员专享',
      };
      const list = FunctionUtils.deepClone(this.homeForm2.value);
      list[i].levelCopyrighting = strMap[e] || '';
      this.homeForm2.value = list;
      console.log('e', e, i);
    },
    querySearch(queryString, cb) {
      this.$Api.mpConfiguration.getCourseSearch(queryString).then(res => {
        cb(res.map(item => {
          item.value = item.title;
          return item;
        }));
      });
    },
    handleSelect(item) {
      console.log('item', item);
      this.selectItem = item;
    },
    handleSelect4(item, index) {
      const list = FunctionUtils.deepClone(this.homeForm4.value);
      item.imageUrl = '';
      list[index] = item;
      this.homeForm4.value = list;
    },
    addClass() {
      if (!this.selectItem) {
        this.$message.error('请选择添加课程');
        return false;
      }
      if (this.homeForm3?.value?.length) {
        if (this.homeForm3.value.some(item => item.courseId === this.selectItem.id)) {
          this.$message.error('该课程已经添加，请勿重复！');
          return false;
        }
      }
      const addObj = {
        imageUrl: this.selectItem.imageUrl,
        courseId: this.selectItem.id,
        courseName: this.selectItem.title,
        seriesTag: this.selectItem.seriesTag,
        tag: this.classTag,
      };

      this.homeForm3.value = Array.isArray(this.homeForm3.value)
        ? [...this.homeForm3.value, addObj]
        : [addObj];
      this.selectItem = null;
      this.className = '';
      this.classTag = '';
    },
    removeClass(i) {
      if (Array.isArray(this.homeForm3.value)) {
        this.homeForm3.value.splice(i, 1);
      }
    },
    sendHomeBanner1() {
      const str = this.homeForm1.id ? '修改' : "保存";
      try {
        this.$refs.homeForm1.validate((valid) => {
          if (!valid) return;
          this.homeForm1.value = this.homeForm1.value.map(item => {
            return {
              ...item,
              channelVisible: !item.channelVisible ? 0 : item.channelVisible,
            };
          });
          const api = this.homeForm1.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
          api(this.homeForm1).then(res => {
            this.$message.success(`${str}成功`);
            console.log('res', res);
          });
        });
      } catch (error) {
        this.$message.success(`${str}成功`);
      }
    },
    sendHomeBanner2() {
      const str = this.homeForm2.id ? '修改' : "保存";
      const api = this.homeForm2.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
      api(this.homeForm2).then(res => {
        this.$message.success(`${str}成功`);
        console.log('res', res);
      });
    },
    sendHomeBanner3() {
      const str = this.homeForm3.id ? '修改' : "保存";
      const api = this.homeForm3.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
      api(this.homeForm3).then(res => {
        this.$message.success(`${str}成功`);
        console.log('res', res);
      });
    },
    sendHomeBanner5() {
      const str = this.homeForm5.id ? '修改' : "保存";
      try {
        this.$refs.homeForm5.validate((valid) => {
          if (!valid) return;
          const api = this.homeForm5.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
          this.homeForm5.segment = 'home_page_module';
          api(this.homeForm5).then(res => {
            this.$message.success(`${str}成功`);
          });
        });
      } catch (error) {
        this.$message.error(`${str}失败`);
      }
    },
    sendHomeBanner4() {
      const str = this.homeForm4.id ? '修改' : "保存";
      const api = this.homeForm4.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
      this.homeForm4.segment = 'course_page_module';
      if (this.homeForm4.value.length) {
        this.homeForm4.value.forEach(item => {
          if (!item?.courseId && item.id) {
            item.courseId = item.id;
          }
        });
        let vaild = true;
        this.homeForm4.value.forEach(item => {
          console.log('item', item);
          if (!item.courseId || !item.imageUrl) {
            vaild = false;
          }
        });
        if (!vaild) {
          this.$message.error('请选择课程和图片');
          return;
        }
      } else {
        this.$message.error('请选择课程和图片');
        return;
      }

      api(this.homeForm4).then(res => {
        this.$message.success(`${str}成功`);
        console.log('res', res);
      });
    },
    // 保存课程/活动频道
    sendClassEvent() {
      const str = this.classEventForm.id ? '修改' : "保存";
      const api = this.classEventForm.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
      api(this.classEventForm).then(res => {
        this.$message.success(`${str}成功`);
        console.log('res', res);
      });
    },
    // 保存积分兑换频道
    sendIntegralExchange() {
      const str = this.integralExchangeForm.id ? '修改' : "保存";
      const api = this.integralExchangeForm.id ? this.$Api.channelPage.updateCPCC : this.$Api.channelPage.addCPCC;
      api(this.integralExchangeForm).then(res => {
        this.$message.success(`${str}成功`);
        console.log('res', res);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.channel-page {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: calc(100vh - 178px);
  .btns {
    justify-content: center;

    margin-top: 30px;
    .el-button {
      width: 120px;
      height: 50px;
    }
  }
  .w-750 {
    width: 750px !important;
  }
  .w-360 {
    width: 360px !important;
  }
  :deep(.common-input) {
    height: 32px !important;

    background: #f7f7f7;

    line-height: 32px !important;
    input {
      height: 32px !important;

      line-height: 32px !important;
    }
    :deep(.el-input__inner) {
      &::placeholder {
        color: #bbbbbb;
      }
    }
    &.underline {
      .el-input__inner {
        text-decoration: underline;
      }
    }
    .el-input__inner {
      color: #494949;
    }
  }
  :deep(.autocomplete-input) {
    width: 360px;
    height: 32px;
    .el-input {
      height: 32px !important;
      input {
        height: 32px;

        line-height: 32px;
      }
    }
    .el-input-group__prepend {
      padding: 0 8.5px;

      background-color: #fff;
    }
    .el-input__inner {
      &:focus {
        border-left: 1px solid #1c1c1c;
      }
      &::placeholder {
        font-size: 14px;
      }
    }
  }
  :deep(.el-tabs__item) {
    min-width: 103px;

    text-align: center;
  }
  :deep(.channel-tabs) {
    flex: 1;

    height: 100%;
    .el-tabs__header {
      margin: 0 0 30px;
    }
    .el-tabs__content {
      .el-tab-pane {
        &:first-of-type {
          .home-form {
            .home-form-body {
              .home-banner-form {
                .el-form-item {
                  margin-bottom: 16px;
                }
                .card {
                  display: flex;
                  overflow: auto;
                  align-items: center;

                  width: 100%;
                  padding: 30px 50px;

                  color: #494949;
                  background: #f7f7f7;

                  font-size: 14px;
                  font-weight: 400;
                  line-height: 20px;

                  .el-icon-remove-outline {
                    margin-right: 58px;

                    color: #bbbbbb;

                    font-size: 30px;
                    line-height: 32px;
                    &:hover {
                      cursor: pointer;

                      color: #000;
                    }
                  }

                  .index {
                    margin-right: 60px;

                    white-space: nowrap;
                  }
                  .img-wrap {
                    margin-right: 60px;
                  }
                  .title {
                    margin-right: 10px;

                    white-space: nowrap;
                  }
                  .operate-wrap {
                    margin-left: 60px;
                  }
                  .mainTitleWrap {
                    .el-input + .el-input {
                      margin-left: 30px;
                    }
                  }

                  &.card {
                    margin-bottom: 30px;
                  }
                }
              }
              .banner-class-wrap {
                width: 100%;

                font-size: 14px;
                font-weight: 500;
                .banner-class-box {
                  overflow: auto;

                  width: 100%;
                  margin-bottom: 30px;
                  padding: 30px;

                  background: #f7f7f7;

                  .first {
                    margin-right: 30px;
                    img {
                      width: 150px;
                      height: 150px;

                      border: 1px dashed #b6b6b7;
                      border-radius: 4px;
                    }
                  }
                  .second {
                    flex-direction: column;

                    width: auto;
                    height: 150px;

                    color: #494949;
                    .second-item {
                      height: 34px;

                      line-height: 34px;
                    }
                    .second-operate {
                      margin-top: auto;

                      cursor: pointer;

                      color: #0085d0;
                    }
                  }
                }
              }
              .add-class-wrap {
                overflow: auto;

                width: 100%;
                padding: 30px 50px;

                color: #494949;
                background: #f7f7f7;

                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                .title {
                  margin-bottom: 20px;

                  font-size: 16px;
                  font-weight: 500;
                  line-height: 23px;
                }
                .home-class-form {
                  .el-form-item {
                    margin-bottom: unset;

                    .el-form-item__content {
                      margin-left: 10px;
                    }
                  }
                }
              }
            }
          }
        }
        .two-form-body {
          .two-banner-form {
            .el-form-item {
              margin-bottom: 16px;
            }
            .card {
              display: flex;
              overflow: auto;
              align-items: center;

              width: 100%;
              padding: 30px 50px;

              color: #494949;
              background: #f7f7f7;

              font-size: 14px;
              font-weight: 400;
              line-height: 20px;

              .el-icon-remove-outline {
                margin-right: 58px;

                color: #bbbbbb;

                font-size: 30px;
                line-height: 32px;
                &:hover {
                  cursor: pointer;

                  color: #000;
                }
              }

              .index {
                margin-right: 60px;

                white-space: nowrap;
              }
              .img-wrap {
                width: 450px;
                margin-right: 60px;
                .upload-box {
                  width: 450px !important;
                  .uploader-image {
                    width: 450px !important;
                    height: 150px !important;
                  }
                }
              }
              .operate-wrap {
                margin-left: 60px;
              }

              &.card {
                margin-bottom: 30px;
              }
            }
          }
          .banner-class-wrap {
            width: 100%;

            font-size: 14px;
            font-weight: 500;
            .banner-class-box {
              overflow: auto;

              width: 100%;
              margin-bottom: 30px;
              padding: 30px;

              background: #f7f7f7;

              .first {
                margin-right: 30px;
                img {
                  width: 150px;
                  height: 150px;

                  border: 1px dashed #b6b6b7;
                  border-radius: 4px;
                }
              }
              .second {
                flex-direction: column;

                width: auto;
                height: 150px;

                color: #494949;
                .second-item {
                  height: 34px;

                  line-height: 34px;
                }
                .second-operate {
                  margin-top: auto;

                  cursor: pointer;

                  color: #0085d0;
                }
              }
            }
          }
          .add-class-wrap {
            overflow: auto;

            width: 100%;
            padding: 30px 50px;

            color: #494949;
            background: #f7f7f7;

            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            .title {
              margin-bottom: 20px;

              font-size: 16px;
              font-weight: 500;
              line-height: 23px;
            }
            .home-class-form {
              .el-form-item {
                margin-bottom: unset;

                .el-form-item__content {
                  margin-left: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
  .card-flex{
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 30px 0 15px 50px;
    background-color: #F7F7F7;
    margin-bottom: 30px;
    &:last-child{
      margin-bottom: 0;
    }
  }
  .btn-box{
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
  }
  .add-btn{
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 34px;
    gap: 8px;
    color: #9B9B9B;
    font-size: 14px;
    border: 1px dotted #9B9B9B;
    border-radius: 8px;
    cursor: pointer;
  }
}
</style>

